<script>
export default {
  props: {
    on: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<template>
  <div>
    <svg v-if="!on" width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5 18.5001C3.34315 18.5001 2 17.1569 2 15.5001V5.5C2 3.84315 3.34315 2.5 5 2.5H15C16.6569 2.5 18 3.84315 18 5.5L18 15.5001C18 17.1569 16.6569 18.5001 15 18.5001H5Z"
        fill="white"
        stroke="#DBDBDB"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg v-else width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5 18.5001C3.34315 18.5001 2 17.1569 2 15.5001V5.5C2 3.84315 3.34315 2.5 5 2.5H15C16.6569 2.5 18 3.84315 18 5.5L18 15.5001C18 17.1569 16.6569 18.5001 15 18.5001H5Z"
        fill="#0058AA"
      />
      <path d="M12.6667 8.83325L8.19205 12.8333L6.66675 11.4698" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  </div>
</template>

<style scoped lang="scss"></style>
